import React from 'react';
import BooksTrackerPanel from '../books/BooksTrackerPanel';

const BookTrackerWidget: React.FC = () => (
  <BooksTrackerPanel
    title="Books"
    emptyMessage="No reading or paused books yet"
    variant="widget"
  />
);

export default BookTrackerWidget;
